import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { DuplicateRowsFieldProps, IndicatorFactorsPicker } from 'app/area/indicator-factors/types';
import { SinglePickerCreator } from 'app/area/indicator-factors/common/single-picker-creator';
import { codePickersId } from 'app/area/indicator-factors/item/code-pickers/types';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const Source = (props: DuplicateRowsFieldProps) => {
  const { list: { codetableOptions = {}, duplicateRows },
    validation, translation } = props;

  const codetableId = codePickersId.source;
  const codetableKey = IndicatorFactorsPicker.source;

  const codeOptions = (!!codetableOptions[codetableKey]
    && codetableOptions[codetableKey].codes || []) as CodeComplexValue<number>[];

  const valueItem = duplicateRows?.form && duplicateRows?.form[codetableKey];

  const onChange = (value: CodeComplexValue<number> | Date) => {
    props.resetValidation(codetableKey);
    props.updateByKey(codetableKey, value);
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    props.loadCodetableOptions(id, codetableId, {
      ...loadOptionsParams, displayNotSelected: false
    });
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId);

  return <SinglePickerCreator
    id={codetableKey}
    label={translation.source}
    size={6}
    valueItem={valueItem}
    options={codeOptions}
    fetchingOptions={codetableOptions[codetableKey] && codetableOptions[codetableKey].fetching}
    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    validation={valueItem && validation?.source}
    extraFooterButton={extraFooterButton}
  />;
};
